import React  from 'react';
import NextButton from '../../components/nextButton';

import pr1 from './images/pr1.png';
import pr2 from './images/pr2.png';
import pr3 from './images/pr3.png';

import './style.css';

{/* <div className="head-rebus">Чтобы пройти дальше нужно справится с ребусами. Надеюсь, что ты умеешь их решать!<br/><span className="text-span-3">Вот тебе некоторые правила:</span><br/></div> */}

const PageRebusBegin = ({ onNextLevel, messNext, answer, setAnswer } ) => {
  return ( 
		<div className="section-info section-rebus-begin">
			<div className="content-rebus w-container">
				<div className="head-rebus">Чтобы пройти дальше нужно справится с ребусами. Надеюсь, что ты умеешь их решать!<br/><span className="text-span-3">Вот тебе некоторые правила:</span><br/></div>
				<div className="rebus-box">
					<div className="rebus">
						<div className="rebus-img-wrp"><img src={pr1} loading="lazy" width="12" alt=""/></div>
						<div>
							<div className="text-block-3">Убирает буквы в начале или конце слова</div>
						</div>
					</div>
					<div className="rebus">
						<div className="rebus-img-wrp"><img src={pr2} loading="lazy" alt=""/></div>
						<div>
							<div className="text-block-3">Заменяет указанную по счету букву на другую</div>
						</div>
					</div>
					<div className="rebus">
						<div className="rebus-img-wrp"><img src={pr3} loading="lazy" alt=""/></div>
						<div>
							<div className="text-block-3">Если предмет нарисован в перевёрнутом виде, название его надо читать справа налево</div>
						</div>
					</div>
				</div>
				<NextButton classes="button-q margin w-button" onNextLevel={onNextLevel} messNext="вперёд" />
				</div>
		</div>

  );
}

export default PageRebusBegin;
